import type { ReactNode } from "react";
import useTranslator from "../../hooks/useTranslator";
import { Button, Icon } from "../design";
import "./AuthForm.css";

interface AuthStepHeaderProps {
  /** leave out on pages with nowhere to go back to (opened from an email) */
  onBack?: () => void;
  title: string;
  subtitle?: string;
  /** small role label on the right of the Back row, for example Tenant */
  pill?: { icon: string; label: string };
  children?: ReactNode;
}

/** Top of every login / sign-up step: Back (and role), title, one-line help. */
const AuthStepHeader = ({
  onBack,
  title,
  subtitle,
  pill,
  children,
}: AuthStepHeaderProps) => {
  const { _t } = useTranslator();
  return (
    <header className="auth-step-header">
      {(onBack || pill) && (
        <div className="auth-step-top">
          {onBack && (
            <Button
              variant="ghost"
              size="sm"
              className="auth-back"
              onClick={onBack}
              iconStart={<Icon name="chevronLeft" size={16} />}
            >
              {_t("back")}
            </Button>
          )}
          {pill && (
            <span className="auth-role-pill">
              <span className="auth-role-icon">
                <img src={pill.icon} alt="" />
              </span>
              {pill.label}
            </span>
          )}
        </div>
      )}
      <h2 className="auth-step-title">{title}</h2>
      {subtitle && <p className="auth-step-sub">{subtitle}</p>}
      {children}
    </header>
  );
};

export default AuthStepHeader;
